import { ref, type Ref } from "vue";
import { Network } from "@capacitor/network";

export interface UseNetworkOpts {
  onReconnect?: () => void | Promise<void>;
}

export interface UseNetworkApi {
  isOnline: Ref<boolean>;
}

export function useNetwork(opts: UseNetworkOpts = {}): UseNetworkApi {
  const isOnline = ref<boolean>(true);
  let wasOnline = true;

  (async () => {
    const status = await Network.getStatus();
    isOnline.value = status.connected;
    wasOnline = status.connected;
  })();

  Network.addListener("networkStatusChange", (status) => {
    const nowOnline = status.connected;
    isOnline.value = nowOnline;
    if (!wasOnline && nowOnline && opts.onReconnect) {
      Promise.resolve(opts.onReconnect()).catch((err) => {
        console.warn("onReconnect handler threw", err);
      });
    }
    wasOnline = nowOnline;
  });

  return { isOnline };
}
